/** @format */

import { Grid } from '@mui/material';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { getKnowledgeBaseLink } from 'src/utils/helper';
import { KnowledgeBaseRating } from './rating';

type KnowledgeBaseListItem = {
  nid?: string | number;
  title?: string;
  date?: number;
  category?: string;
  content?: string;
  rating?: number;
};

type KnowledgeBaseItemProps = {
  kb?: string;
  item?: KnowledgeBaseListItem;
};

export const KnowledgeBaseItem = ({ kb, item }: KnowledgeBaseItemProps) => {
  const { title, date, content, rating } = item || {};
  return (
    <Link to={getKnowledgeBaseLink(kb, item)} className="knowledge_base-widget--list-item">
      <Grid className="knowledge_base-widget--list-item-top">
        <Grid className="knowledge_base-widget--list-item-date-title">
          <Grid className="knowledge_base-widget--list-item-title">{title}</Grid>
          <Grid className="knowledge_base-widget--list-item-date">
            {date ? format(new Date(date * 1000), 'dd.MM.yyyy') : '00.00.0000'}
          </Grid>
        </Grid>
        {rating && rating !== 0 ? <KnowledgeBaseRating rating={rating} /> : null}
      </Grid>
      <Grid className="knowledge_base-widget--list-item-text">{content}</Grid>
    </Link>
  );
};
